var _style, _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "katman_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 800 600"
    },
    viewBox: "0 0 800 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    id: "IBM_Cloud",
    d: "M298.3 344.4v-5.9h8.2v-46.9h-8.2v-5.9h23.5v5.9h-8.2v46.9h8.2v5.9h-23.5zm36.4-58.7h24.1c9.7 0 15.6 6 15.6 15.1 0 8.7-5.6 11.9-9.5 12.4v.5c4.2.3 11.5 3.9 11.5 13.6s-6.5 17-15.1 17h-26.6v-58.6zm7 25.4h16.2c5.5 0 8.9-2.9 8.9-8.1v-2.9c0-5.2-3.4-8.1-8.9-8.1h-16.2v19.1zm0 27.1h17.4c6.1 0 9.7-3.2 9.7-9.1v-2.9c0-5.9-3.7-9.1-9.7-9.1h-17.4v21.1zm93.4-43.2h-.4l-5 9.8-14 25.5-13.9-25.5-5-9.7h-.4v49.3h-6.9v-58.7h9.2l16.8 31.6h.3l16.9-31.6h9.2v58.6H435l.1-49.3zm35.4 20.5c0-19.8 10.2-30.7 26-30.7 10.8 0 17.6 4.4 21.9 13.8l-11 5.7c-1.5-4.9-4.6-8.1-10.9-8.1-7.5 0-12.4 5-12.4 14.3v9.4c0 9.2 5 14.3 12.4 14.3 6.3 0 9.9-3.9 11.7-8.7l10.4 6.1c-4.4 8.9-11.3 14-22.1 14-15.8-.2-26-10.3-26-30.1zm68.7 28.9c-8.5 0-12.4-4.3-12.4-12.1v-50.1h12.4v52.5h5.5v9.7h-5.5zm10.3-22.1c0-14.2 7.7-23 20.7-23 12.9 0 20.7 8.8 20.7 23s-7.7 23.1-20.7 23.1-20.7-8.9-20.7-23.1zm28.4 4.5v-9c0-5.5-2.9-8.7-7.7-8.7-4.9 0-7.7 3.2-7.7 8.7v9c0 5.5 2.9 8.7 7.7 8.7 4.8.1 7.7-3.1 7.7-8.7zm47.8 10.2h-.4c-1.5 4.5-5.1 8.4-12.4 8.4-9 0-13.8-6.3-13.8-17.4v-27.7h12.4v26.6c0 5.4 1.8 8.4 6.3 8.4 3.9 0 7.8-2.2 7.8-6.4v-28.7H638v44.1h-12.4c.1.1.1-7.3.1-7.3zm51.1 0h-.4c-1.3 4.8-6.1 8.4-11.9 8.4-11.2 0-17-8.1-17-23.1 0-15 5.8-23 17-23 5.7 0 10.6 3.5 11.9 8.4h.4v-25.5h12.4v62.2h-12.4V337zm0-8.2v-13c0-4-3.4-6.5-8.1-6.5s-8.1 3.6-8.1 9.2v7.6c0 5.5 3.4 9.2 8.1 9.2s8.1-2.4 8.1-6.5z",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 152.4,
    height: 134.9,
    x: 107,
    y: 231.9,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "SVGID_00000080927719334466558720000003985512822422240655_",
    width: 152.4,
    height: 134.9,
    x: 107,
    y: 231.9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 222.7h184.5v154H90v-154z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2 285.8c-.5 0-1-.1-1.4-.4l-13.6-7.9c-1.3-.7-1.9-2.2-1.4-3.6.5-1.5 2.2-2.3 3.7-1.7.2.1.3.1.5.2l13.6 7.9c1.4.8 1.9 2.5 1.3 3.9-.6 1-1.6 1.6-2.7 1.6zm23.6-23.5c-1 0-2-.6-2.5-1.4l-7.9-13.6c-.7-1.2-.5-2.8.6-3.8 1.2-1 3-.9 4.1.3.1.1.2.3.3.4l7.9 13.6c.8 1.3.5 3-.8 4-.6.3-1.1.5-1.7.5zm29.2-11.7v-15.5c0-1.6 1.2-2.9 2.8-3.1 1.6-.1 2.9 1.2 3 2.8v16c0 1.6-1.3 2.9-2.9 2.9h-.1c-1.6-.2-2.8-1.5-2.8-3.1zm35.1 11.7c-.6 0-1.2-.2-1.6-.5-1.2-.9-1.6-2.6-.8-4l7.9-13.6c.8-1.4 2.6-1.9 3.9-1.1.1.1.3.2.4.3 1.1 1 1.3 2.6.6 3.8l-7.9 13.6c-.5.9-1.5 1.5-2.5 1.5zm23.5 23.5c-1.1 0-2.1-.6-2.6-1.5-.7-1.4-.1-3.2 1.3-3.9l13.5-7.8c1.2-.7 2.8-.5 3.7.5 1 1.2.9 3-.3 4.1-.1.1-.3.2-.4.3l-13.8 7.9c-.4.3-.9.4-1.4.4z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: -19192.705,
    x2: -16274.898,
    y1: -10879.721,
    y2: -10365.253,
    gradientTransform: "rotate(-135.001 10.219 -70.831) scale(.02051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.03
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.74
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.3 351.7c-20.2-20.2-20.2-53 0-73.2 20.2-20.2 53-20.2 73.2 0 1.5 1.5 2.8 3 4.1 4.6.9 1.1 1.7 2.3 2.5 3.5l-4.8 3.2c-.7-1.1-1.4-2.1-2.2-3.1-1.1-1.4-2.4-2.8-3.7-4.1-18-18-47.1-18-65.1 0-18 18-18 47.1 0 65.1l-4 4z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8 366.9h-79.7c-18.5-.1-33.3-15.2-33.2-33.7h5.8c-.1 15.3 12.2 27.8 27.5 27.9h79.6c18.7 0 33.8-15.1 33.8-33.8 0-8.3-3.1-16.3-8.6-22.5l4.3-3.8c14.6 16.3 13.2 41.3-3.1 55.9-7.2 6.4-16.6 10-26.4 10z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043415938796937368740000001250501632105575082_",
    x1: 7656.852,
    x2: 9366.988,
    y1: 17970.063,
    y2: 16982.703,
    gradientTransform: "translate(-53.5 -41.29) scale(.02051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.7 333.2h-5.8c.1-16.2 11.9-30 27.9-32.7l1 5.7c-13.3 2.2-23 13.6-23.1 27z",
    style: {
      fill: "url(#SVGID_00000043415938796937368740000001250501632105575082_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004528429678159218410000005172733148142063283_",
    x1: 11565.651,
    x2: 14166.69,
    y1: 18156.17,
    y2: 15973.643,
    gradientTransform: "translate(-53.5 -41.29) scale(.02051)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    style: {
      stopColor: "#fff",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.764
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.1 327.1h-5.8c.2-21.8 18-39.4 39.8-39.3 11.2.1 21.8 4.9 29.2 13.2l-4.3 3.8c-12.4-13.9-33.8-15.1-47.7-2.7-7.1 6.4-11.2 15.4-11.2 25z",
    style: {
      fill: "url(#SVGID_00000004528429678159218410000005172733148142063283_)"
    }
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067946601360995204440000011549237995636409740_",
    x1: 6738.999,
    x2: 4597.268,
    y1: 6799.41,
    y2: 10509.003,
    gradientTransform: "translate(-19.634 -2.32) scale(.03588)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50ffd2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0064ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 285.7c-.5 0-1-.1-1.4-.4l-13.6-7.9c-1.3-.7-1.9-2.2-1.4-3.6.5-1.5 2.2-2.3 3.7-1.7.2.1.3.1.5.2l13.6 7.9c1.4.8 1.9 2.5 1.3 3.9-.7 1-1.6 1.6-2.7 1.6zm23.5-23.5c-1 0-2-.6-2.5-1.4l-7.9-13.6c-.7-1.2-.5-2.8.6-3.8 1.2-1 3-.9 4.1.3.1.1.2.3.3.4l7.9 13.6c.8 1.3.5 3-.8 4-.5.3-1.1.5-1.7.5zm29.3-11.7V235c0-1.6 1.2-2.9 2.8-3.1 1.6-.1 2.9 1.2 3 2.8v16c0 1.6-1.3 2.9-2.9 2.9h-.1c-1.6-.2-2.8-1.5-2.8-3.1zm35.1 11.7c-.6 0-1.2-.2-1.6-.5-1.2-.9-1.6-2.6-.8-4l7.9-13.6c.8-1.4 2.6-1.9 3.9-1.1.1.1.3.2.4.3 1.1 1 1.3 2.6.6 3.8l-7.9 13.6c-.6.9-1.5 1.5-2.5 1.5zm23.5 23.5c-1.1 0-2.1-.6-2.6-1.5-.7-1.4-.1-3.2 1.3-3.9l13.5-7.8c1.2-.7 2.8-.5 3.7.5 1 1.2.9 3-.3 4.1-.1.1-.3.2-.4.3l-13.8 8c-.4.2-.9.3-1.4.3zm-92.3 65.9c-20.2-20.2-20.2-53 0-73.2 20.2-20.2 53-20.2 73.2 0 1.5 1.5 2.8 3 4.1 4.6.9 1.1 1.7 2.3 2.5 3.5l-4.8 3.2c-.7-1.1-1.4-2.1-2.2-3.1-1.1-1.4-2.4-2.8-3.7-4.1-18-18-47.1-18-65.1 0-18 18-18 47.1 0 65.1l-4 4zm73.5 15.2h-79.7c-18.5-.1-33.3-15.2-33.2-33.7h5.8c-.1 15.3 12.2 27.8 27.5 27.9h79.6c18.7 0 33.8-15.1 33.8-33.8 0-8.3-3.1-16.3-8.6-22.5l4.3-3.8c14.6 16.3 13.2 41.3-3.1 55.9-7.3 6.4-16.7 10-26.4 10zm-107.1-33.7H107c.1-16.2 11.9-30 27.9-32.7l1 5.7c-13.3 2.2-23 13.6-23.1 27zm73.3-6.1h-5.8c.2-21.8 18-39.4 39.8-39.3 11.2.1 21.8 4.9 29.2 13.2l-4.3 3.8c-12.4-13.9-33.8-15.1-47.7-2.7-7 6.4-11.1 15.4-11.2 25z",
    style: {
      mask: "url(#SVGID_00000080927719334466558720000003985512822422240655_)",
      fill: "url(#SVGID_00000067946601360995204440000011549237995636409740_)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6);
export default __webpack_public_path__ + "static/media/c6.eaef65b78e9114c18ccd68ad7049724b.svg";
export { ForwardRef as ReactComponent };